import { render, staticRenderFns } from "./CreatePage.vue?vue&type=template&id=c43b395e&scoped=true"
import script from "./CreatePage.vue?vue&type=script&lang=js"
export * from "./CreatePage.vue?vue&type=script&lang=js"
import style0 from "./CreatePage.vue?vue&type=style&index=0&id=c43b395e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43b395e",
  null
  
)

export default component.exports